import { User } from 'interfaces';

import { createAnonymousFirebaseUser } from './createAnonymousFirebaseUser';
import { setUser } from './setUser';
import { useAuthStore } from '..';

export const getOrCreateUser = async () => {
  let user = useAuthStore.getState().user;
  if (user == null) {
    const firebaseUser = await createAnonymousFirebaseUser();
    setUser(firebaseUser);
    user = new User({ firebaseUser });
  }
  return user;
};
